import { useEffect, useState } from "react";
import { getData } from "../helpers/api";
import TableLayout from "../components/layouts/TableLayout";
import { INITIAL_ACTIONS } from "../constants/others";
import AddDeliveryCompanyKey from "../components/deliveryCompany/AddDeliveryCompanyKey";
import withRoleProtection from "../components/withRoleProtection";

const INITIAL_VALUE = {
    publicKey: "",
    secretKey: "",
    deliveryCompany: undefined,
    name:""
}
const DeliveryCompany = () => {
    const [deliveryCompanyKey, setDeliveryCompanyKey] = useState(INITIAL_VALUE)
    const [deliveryCompanyKeys, setDeliveryCompanyKeys] = useState([])
    const columns = [
        {
            title: "Nom de compte",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Société",
            dataIndex: "deliveryCompany",
            key: "deliveryCompany"
        },
        {
            title: "Secret Key",
            dataIndex: "secretKey",
            key: "secretKey"
        },
        {
            title: "Public Key",
            dataIndex: "publicKey",
            key: "publicKey"
        },
    ]
    const getdeliveryCompanyKeys = async () => {
        try {
            const res = await getData("/delivery-company-keys");
            console.log(res.data)
            setDeliveryCompanyKeys(res.data.map((el) => ({ ...el, deliveryCompany: el.deliveryCompany.name })))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getdeliveryCompanyKeys()
    }, [])

    const handleCancel = () => {
        setDeliveryCompanyKey({ ...INITIAL_VALUE, ...INITIAL_ACTIONS })
    }

    const handleAfterAddingDeliveryCompanyKey = () => {
        handleCancel()
        getdeliveryCompanyKeys()
    }
    return (
        <>
            {(deliveryCompanyKey.add || deliveryCompanyKey.edit) && <AddDeliveryCompanyKey
                handleAfterAddingDeliveryCompanyKey={handleAfterAddingDeliveryCompanyKey}
                initialValue={deliveryCompanyKey}
                isModalOpen={deliveryCompanyKey.add || deliveryCompanyKey.edit}
                handleCancel={handleCancel}
            />}
            <TableLayout
                columns={columns}
                dataSource={deliveryCompanyKeys}
                setAddElementModal={() => { setDeliveryCompanyKey({ ...INITIAL_VALUE, add: true }) }}
            />
        </>
    );
}

export default withRoleProtection(DeliveryCompany, ['super admin']);